<template>
  <div>

    <loading v-show="showLoading"></loading>

    <div class="after-type-back"  v-show="!showLoading" >

      <div class="after-type-content">
        <div class="after-type-each">
          <div class="after-type-goods">
            <div class="after-type-goods-each">
              <div class="after-type-goods-left">
                <van-image :src="imageUrl" fit="cover"></van-image>
              </div>
              <div class="after-type-goods-right">
                <div>
                  <div class="after-type-goods-name">
                    {{productName}}
                  </div>
                  <div class="after-type-goods-num">
                    x{{quantity}}
                  </div>
                </div>
                <div class="after-type-goods-div-bottom">
                  <div class="after-type-goods-price">
                    ¥{{price}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="after-type">
        <div class="after-type-div" @click="goCommit(1)">
            <div class="after-type-div-left">
              我要退款 (无需退货)
            </div>
            <div class="after-type-div-right">
              <img src="@/images/icon_arrow@3x.png"/>
            </div>
          </div>
        <!--零售商品除外不显示此项-->
        <div class="after-type-div" @click="goCommit(0)" v-if="isReturns == 'Y'&&onlyRefund=='N'">
            <div class="after-type-div-left">
              我要退货退款
            </div>
            <div class="after-type-div-right">
              <img src="@/images/icon_arrow@3x.png"/>
            </div>
          </div>
      </div>

    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { storeName,prodCatalogId,loginInfo } from '@/router/Constant'
  import {afterCancel,login} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,PullRefresh,Dialog} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';
  import refresh from '@/components/page/common/refresh.vue';
  export default {
    name: "afterType",
    data(){
      return{
        showLoading:true,
        imageUrl:this.$route.query.imageUrl,
        price:this.$route.query.price,
        quantity:this.$route.query.quantity,
        productName:this.$route.query.productName,
        isReturns:this.$route.query.isReturns,
        orderId:this.$route.query.orderId,
        productId:this.$route.query.productId,
        onlyRefund:this.$route.query.onlyRefund,
        orderItemSeqId:this.$route.query.orderItemSeqId
      }
    },

    mounted(){
      setTimeout(() => {
        this.showLoading = false;
        this.isLoading = false;
      }, 1000);
      this.resetScorllView();
    },

    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      [PullRefresh.name]: PullRefresh,
      loading,
      refresh,
      [Dialog.Component.name]: Dialog.Component,
    },

    methods: {

      goCommit(state) {
        this.$router.replace({name:'afterCommit',query:{isReturns:this.isReturns,imageUrl:this.imageUrl,quantity:this.quantity,price:this.price,productName:this.productName,orderId: this.orderId,productId: this.productId,typeId:state,orderItemSeqId:this.orderItemSeqId}})
      },

      // 数据格式化
      resetScorllView() {
        this.$router.afterEach((to,from, next) => {
          window.scrollTo(0,0)
        })
      },
    }
  }
</script>

<style>
  .after-type-back{
    background-color: #F8F8F8;
  }
  .after-type-content{
    width:100%;
    margin-bottom: 0.625rem;
  }
  .after-type-each{
    width:100%;
    background-color: white;
    margin-bottom: 0.625rem;
  }
  .after-type-goods{
    width:100%;
  }
  .after-type-goods-each{
    width:100%;
    padding-bottom: 0.9375rem;
    padding-top: 0.9375rem;
  }
  .after-type-goods-left{
    display: inline-block;
    vertical-align: top;
    height: 5rem;
    margin-left: 1rem;
    margin-right:0.6875rem;
  }
  .after-type-goods-left .van-image{
    width:5rem;
    height: 5rem;
  }
  .after-type-goods-right{
    width:calc(100% - 8rem);
    display: inline-block;
    vertical-align: top;
  }
  .after-type-goods-name{
    font-size: 0.875rem;
    color:#333;
    line-height: 1.25rem;
    width:14rem;
    display: inline-block;
    vertical-align: top;
  }
  .after-type-goods-num{
    float: right;
    vertical-align: top;
    color:#33312E;
    font-size: 0.9375rem;
  }
  .after-type-goods-div-bottom{
    width:100%;
    height: 1.875rem;
    line-height: 1.875rem;
    margin-top: 1rem;
  }
  .after-type-goods-price{
    color:#EB84AB;
    font-size: 1rem;
    display: inline-block;
    vertical-align: top;
  }
  .after-type-goods-div-bottom button{
    float: right;
    width:3.75rem;
    height: 1.40625rem;
    line-height: 1.40625rem;
    border-radius: 0.703125rem;
    color:#EB84AB;
    font-size: 0.75rem;
    text-align: center;
    border: 1px solid #EB84AB;
    padding: 0;
  }

  .after-type{
    width:100%;
    background-color: white;
  }
  .after-type-div{
    width:100%;
    border-bottom: 1px solid #e7e7e7;
    height:2.75rem;
    line-height: 2.75rem;
  }
  .after-type-div-left{
    display: inline-block;
    vertical-align: top;
    font-size: 0.8125rem;
    color:#333312;
    margin-left: 1rem;
    width:20.5rem;
  }
  .after-type-div-right{
    display: inline-block;
    vertical-align: top;
  }
  .after-type-div-right img{
    width:1.5rem;
    height: 1.5rem;
    margin-top: 0.7rem;
  }




</style>



// WEBPACK FOOTER //
// src/components/page/after/afterType.vue